module.exports = __webpack_public_path__ + "custom-config/img/header_info_qihuo.7a042e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/header/info/header_info_qihuo.png
// module id = l/+V
// module chunks = 2 3 4 6 7 8 9